import LogRocket from 'logrocket'

export default {
  initialize(appID: string) {
    // set up LogRocket
    const logrocketAppId: string = appID || ''
    LogRocket.init(logrocketAppId, {
      shouldCaptureIP: false,
      dom: { inputSanitizer: true },
      network: {
        requestSanitizer: request => {
          if (request.url.includes('.mixpanel.com')) {
            // don't include mixpanel events
            return null
          }
          // for everything else, redact body
          request.body = undefined
          return request
        },

        // for all responses, redact body
        responseSanitizer: response => {
          response.body = undefined
          return response
        }
      }
    })
  },

  identify(identifier: string): void {
    LogRocket.identify(identifier)
  }
}